import styled, { css } from 'styled-components';
import { Card, Collapsible } from '@equifinance/shared';
import { ReactNode } from 'react';

export const Container = styled(Card)`${({ theme }) => `
  width: 100%;
  box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.1), 0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  margin-left: ${theme.padding[8]};
  margin-right: ${theme.padding[8]};
  padding: 0 ${theme.padding[11]} ${theme.padding[5]} ${theme.padding[11]};
  color: ${theme.textPrimary};
  border-radius:${theme.padding[3]};
  background: ${theme.colours.neutral[10]};
  color: ${theme.textPrimary};
`}`;

const headerCss = css`${({ theme }) => `
  div, i {
    font-size: ${theme.fontSize[7]};
    font-weight: ${theme.fontWeight.bold};
    line-height: ${theme.fontSize[9]};
    color: ${theme.colours.neutral[2]};
  }

  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 108px;
  padding: 0;
  border-radius: 0;
  gap: ${theme.padding[2]};
  background: ${theme.colours.neutral[10]};
  border-bottom: ${theme.borderWidth[1]} solid ${theme.colours.neutral[4]};
`}`;

const bodyCss = css`${({ theme }) => `
  border-radius: 0px 0px ${theme.padding[4]} ${theme.padding[4]};
  background: ${theme.colours.neutral[9]};
  padding: ${theme.padding[3]} ${theme.padding[9]};
  line-height: ${theme.fontSize[8]};
  font-size: ${theme.fontSize[4]};
`}`;

export type HelpSection = {
  title: string;
  content: ReactNode;
}

export type HelpEntries = Record<number, HelpSection[]>;

export default function HelpPageSections({
  version,
  entries,
}: {
  version: number
  entries: HelpEntries,
}) {
  const sections = entries[version] ?? entries[Math.max(...Object.keys(entries).map(Number))];

  return (
    <Container>
      {sections.map(({ title, content }) => (
        <Collapsible
          id={title}
          key={title}
          headerCss={headerCss}
          bodyCss={bodyCss}
          level={2}
          title={title}
        >
          {content}
        </Collapsible>
      ))}
    </Container>
  );
}
